export default __webpack_public_path__ + "static/media/editdata.2a8ff5e3.svg";